/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Row } from 'react-table';

import { getEstimatedLossLabel } from '@trqk/utils';

import { footerHeight, COLUMN_IDS } from '../../constants';
import { reduceFooterValue } from '../../utils';

interface WorkEstimatedLossFooterProps {
    rows: Row<TrqkGapChannelAudio>[];
}

/**
 * Displays a range of estimated loss values, like: `$1 to $5K`, for all rows that are currently
 * selected.
 * @param props - {@link WorkEstimatedLossFooterProps}
 */
export function WorkEstimatedLossFooter({
    rows,
}: WorkEstimatedLossFooterProps): JSX.Element {
    const summedRange = reduceFooterValue<NumberRange>({
        combineFn: (acc: NumberRange, result: NumberRange) => {
            if (result.min >= 0) {
                acc.min = result.min;
            }

            if (result.max >= 0) {
                acc.max = result.max;
            }

            return acc;
        },
        initialValue: { max: 0, min: 0 },
        reducerFn: (
            acc: NumberRange,
            row: Row<TrqkGapChannelAudio>,
        ): NumberRange => {
            const estimatedLossMax =
                row.values?.[COLUMN_IDS.ESTIMATED_LOSS]?.max ?? 0;
            const estimatedLossMin =
                row.values?.[COLUMN_IDS.ESTIMATED_LOSS]?.min ?? 0;

            if (
                row.isSelected &&
                estimatedLossMax >= 0 &&
                estimatedLossMin >= 0
            ) {
                acc.max += estimatedLossMax;
                acc.min += estimatedLossMin;
            }

            return acc;
        },
        rows,
    });

    return (
        <div className="flex items-center" style={{ height: footerHeight }}>
            <p className="pl-1">{getEstimatedLossLabel(summedRange)}</p>
        </div>
    );
}
